// calls the color customization function from cobot_assets,
// mapping the names coming out of data tags to the names
// expected by customizeColors().
// using the passed-in colors object.
import customizeColors from '@upstream/cobot_assets/src/customize-colors';

export default function (colors) {
  const nameMappings = {
    colorText: 'text',
    colorPrimary: 'primary-70',
    colorHighlight: 'highlight-70',
    colorBackground: 'background',
  };
  let mappedName;
  const mappedColors = {};

  for (var name in colors) {
    mappedName = nameMappings[name];
    mappedColors[mappedName] = colors[name];
  }

  customizeColors({
    colors: mappedColors,
  });
}
